<template>
  <v-form
    ref="form"
    v-model="isValidationOk"
    lazy-validation>
    <v-container
      fill-height
      fluid
      grid-list-xl>
      <v-layout
        wrap>
        <v-flex
          xs12
          md12>
          <v-data-table
            :headers="headers"
            :items="tankAlarms"
            data-testId="data-table"
            hide-actions >
            <template
              slot="headerCell"
              slot-scope="{ header }" >
              <span
                data-testId="span-header-text"
                class="dover-blue-color"
                v-text="header.text" />
            </template>
            <template
              slot="items"
              slot-scope="{ index, item }" >
              <tr
                :style="{backgroundColor: (item.key == 'workingCapacity' ? '#cfdbfb' : item.key == 'theftThreshold' ? '#fff8da' : 'transparent' ) }">
                <td
                  width="15%"
                  class="text-xs-right">{{ item.desc }}</td>
                <td
                  width="5%"
                  class="text-xs-right font-weight-bold">{{ item.key != 'theftThreshold' ? Maglink.RoundFormat(item.level, 0) : "" }}
                  <v-icon
                    v-if="item.key !== 'theftThreshold'"
                    small
                    @click="onOpenDialogNumberInput(index, item, 0)">mdi-pencil</v-icon>
                </td>
                <td
                  width="5%"
                  class="text-xs-right font-weight-bold">{{ Maglink.RoundFormat(item.volume, 0) }}
                  <v-icon
                    small
                    @click="onOpenDialogNumberInput(index, item, 1)">mdi-pencil</v-icon>
                </td>
                <td
                  width="5%"
                  class="text-xs-right font-weight-bold">{{ Maglink.RoundFormat(item.percentage, 0) }}
                  <v-icon
                    small
                    @click="onOpenDialogNumberInput(index, item, 2)">mdi-pencil</v-icon>
                </td>
                <td>
                  <v-slider
                    v-model.number="item.percentage"
                    :max="item.key == 'theftThreshold' ? 20 : 100"
                    :min="item.key == 'workingCapacity' ? 50 : 0"
                    :thumb-color="thumbColor"
                    data-testId="slider"
                    tooltip="always"
                    step="1"
                    thumb-label
                    @input="onSlide(index)"
                    @change="syncData(index)"/>
                </td>
                <td
                  width="1%"/>
              </tr>
            </template>
          </v-data-table>
        </v-flex>
        <MaglinkComponentDialogNumber
          :key="dialogNumber.key"
          :component-key="dialogNumber.componentKey"
          :initial-value="dialogNumber.initialValue"
          :min-value="dialogNumber.minValue"
          :max-value="dialogNumber.maxValue"
          :dialog="dialogNumber.show"
          :custom-par1="dialogNumber.alarmType"
          :custom-par2="dialogNumber.index"
          :title="dialogNumber.title"
          :label-text="dialogNumber.labelText"
          data-testId="MaglinkComponentDialogNumber-dialogNumber"
          @dialogNumberInputClose="onDialogNumberInputClose"/>
        <v-flex
          xs6
          md6/>
        <v-flex
          xs6
          md6
          text-xs-right>
          <v-btn
            :disabled="!isValidationOk || !Maglink.IsAdminUser()"
            data-testId="btn-Save"
            small
            class="mx-0 font-weight-light"
            color="dover-blue"
            @click="saveTank">
            {{ $t('Save') }}
          </v-btn>
        </v-flex>
      </v-layout>
    </v-container>
  </v-form>
</template>

<script>
import Vue from 'vue'

export default {
  props: {
    tank: {
      type: Object,
      required: true,
      default: () => {}
    },
    systemSettings: {
      type: Object,
      required: true,
      default: () => {}
    },
    options: {
      type: Object,
      required: true,
      default: () => {}
    }
  },
  data: () => ({
    isValidationOk: true,
    dialog: false,
    thumbColor: 'dover-blue',
    headers: [],
    tankAlarms: [],
    dialogNumber: {
      key: 0,
      show: false,
      initialValue: 0,
      minValue: 0,
      maxValue: 100,
      alarmType: 0,
      index: 0,
      componentKey: '',
      title: '',
      labelText: ''
    },
    rules: {
      required: [ v => Vue.prototype.Maglink.RulesRequired(v) ]
    }
  }),
  computed: {
    isAEFfloat () {
      return (this.tank.probeWaterFloat === 2)
    },
    isWaterfloat () {
      return (this.tank.probeWaterFloat !== 0 && this.tank.probeWaterFloat !== 2)
    }
  },
  mounted () {
    this.headers = [
      { sortable: false, text: this.$t('Alarm'), align: 'center' },
      { sortable: false, text: this.$t('Level') + ' (' + [ this.options.levelUnits[this.systemSettings.levelUnit || 0].desc ] + ')', align: 'right' },
      { sortable: false, text: this.$t('Volume') + ' (' + [ this.options.volumeUnits[this.systemSettings.volumeUnit || 0].desc ] + ')', align: 'right' },
      { sortable: false, text: '%', align: 'right' },
      { sortable: false, text: this.$t('Thresholds'), align: 'center' },
      { sortable: false, text: '', align: 'center' }
    ]

    this.tankAlarms.push({ desc: this.$t('Safe working capacity'), key: 'workingCapacity', max: 100, level: this.getLevelFromStrapTable((this.tank.workingCapacity / 100) * this.tank.maxVolume), volume: (this.tank.workingCapacity / 100) * this.tank.maxVolume, percentage: this.Maglink.RoundFormat(this.tank.workingCapacity, 0) })
    this.tankAlarms.push({ desc: this.$t('High') + ' ' + this.$t('High'), key: 'alarmHHLevel', max: this.tank.maxLevel, level: this.tank.alarmHHLevel, volume: this.getVolumeFromStrapTable(this.tank.alarmHHLevel), percentage: this.Maglink.RoundFormat((100 * this.getVolumeFromStrapTable(this.tank.alarmHHLevel)) / this.tank.maxVolume, 0) })
    this.tankAlarms.push({ desc: this.$t('High'), key: 'alarmHLevel', max: this.tank.maxLevel, level: this.tank.alarmHLevel, volume: this.getVolumeFromStrapTable(this.tank.alarmHLevel), percentage: this.Maglink.RoundFormat((100 * this.getVolumeFromStrapTable(this.tank.alarmHLevel)) / this.tank.maxVolume, 0) })
    this.tankAlarms.push({ desc: this.$t('Low'), key: 'alarmLLevel', max: this.tank.maxLevel, level: this.tank.alarmLLevel, volume: this.getVolumeFromStrapTable(this.tank.alarmLLevel), percentage: this.Maglink.RoundFormat((100 * this.getVolumeFromStrapTable(this.tank.alarmLLevel)) / this.tank.maxVolume, 0) })
    this.tankAlarms.push({ desc: this.$t('Low') + ' ' + this.$t('Low'), key: 'alarmLLLevel', max: this.tank.maxLevel, level: this.tank.alarmLLLevel, volume: this.getVolumeFromStrapTable(this.tank.alarmLLLevel), percentage: this.Maglink.RoundFormat((100 * this.getVolumeFromStrapTable(this.tank.alarmLLLevel)) / this.tank.maxVolume, 0) })
    if (this.isWaterfloat) {
      this.tankAlarms.push({ desc: this.$t('HH Water'), key: 'alarmWaterHHLevel', max: this.tank.maxLevel, level: this.tank.alarmWaterHHLevel, volume: this.getVolumeFromStrapTable(this.tank.alarmWaterHHLevel), percentage: this.Maglink.RoundFormat((100 * this.getVolumeFromStrapTable(this.tank.alarmWaterHHLevel)) / this.tank.maxVolume, 0) })
      this.tankAlarms.push({ desc: this.$t('Water'), key: 'alarmWaterLevel', max: this.tank.maxLevel, level: this.tank.alarmWaterLevel, volume: this.getVolumeFromStrapTable(this.tank.alarmWaterLevel), percentage: this.Maglink.RoundFormat((100 * this.getVolumeFromStrapTable(this.tank.alarmWaterLevel)) / this.tank.maxVolume, 0) })
    } else {
      if (!this.isAEFfloat) {
        this.tank.alarmWaterHHLevel = 0
        this.tank.alarmWaterLevel = 0
      }
    }
    this.tankAlarms.push({ desc: this.$t('Sudden loss'), key: 'theftThreshold', max: this.tank.maxVolume * 0.2, level: 0, volume: this.tank.theftThreshold, percentage: this.Maglink.RoundFormat((100 * this.tank.theftThreshold) / this.tank.maxVolume, 0) })
    this.checkThresholds()
  },
  methods: {
    onOpenDialogNumberInput (index, item, alarmType) {
      // 0=level; 1=volume; 2=perc
      if (alarmType === 0) {
        this.dialogNumber.initialValue = this.Maglink.RoundFormat(item.level, 0)
        this.dialogNumber.maxValue = this.tank.maxLevel * 1
      } else if (alarmType === 1) {
        this.dialogNumber.initialValue = this.Maglink.RoundFormat(item.volume, 0)
        this.dialogNumber.maxValue = this.tank.maxVolume * 1
        if (item.key === 'theftThreshold') {
          this.dialogNumber.maxValue *= 0.2
        }
      } else if (alarmType === 2) {
        this.dialogNumber.initialValue = this.Maglink.RoundFormat(item.percentage, 0)
        this.dialogNumber.maxValue = 100
        if (item.key === 'theftThreshold') {
          this.dialogNumber.maxValue *= 0.2
        }
      }

      // 0=level; 1=volume; 2=perc.minValue = 0
      // this.dialogNumber.initialValue = parseFloat(this.dialogNumber.initialValue)
      this.dialogNumber.alarmType = alarmType
      this.dialogNumber.index = index
      this.dialogNumber.title = item.desc
      this.dialogNumber.labelText = item.desc
      this.dialogNumber.componentKey = item.key
      this.dialogNumber.show = true
      // this.dialogNumber.key = this.dialogNumber.key === 0 ? 1 : 2
    },
    onDialogNumberInputClose (componentKey, value, action, alarmType, index) {
      this.dialogNumber.show = false
      // cancel pressed
      if (!action) return

      if (index >= 0) {
        let item = this.tankAlarms[index]

        if (alarmType === 0) { // level
          item.level = value
          item.volume = this.getVolumeFromStrapTable(item.level)
          item.percentage = this.Maglink.RoundFormat((item.volume * 100) / (this.tank.maxVolume * 1), 0)
        } else if (alarmType === 1) { // volume
          item.volume = value
          item.level = this.getLevelFromStrapTable(item.volume)
          item.percentage = this.Maglink.RoundFormat((item.volume * 100) / (this.tank.maxVolume * 1), 0)
        } else if (alarmType === 2) { // %
          item.percentage = this.Maglink.RoundFormat(value, 0)
          item.volume = (item.percentage * this.tank.maxVolume) / 100
          item.level = this.getLevelFromStrapTable(item.volume)
        }
        this.syncData(index)
      }
    },
    onSlide (index) {
      this.tankAlarms[index].level = this.getLevelFromStrapTable((this.tankAlarms[index].percentage * this.tank.maxVolume) / 100)
      this.tankAlarms[index].volume = (this.tankAlarms[index].percentage * this.tank.maxVolume) / 100
    },
    syncData (index) {
      if (this.tankAlarms[index].key === 'workingCapacity') {
        this.tank[this.tankAlarms[index].key] = this.tankAlarms[index].percentage
      } else if (this.tankAlarms[index].key === 'theftThreshold') {
        this.tank[this.tankAlarms[index].key] = this.tankAlarms[index].volume
      } else {
        this.tank[this.tankAlarms[index].key] = this.tankAlarms[index].level
      }

      if (this.tankAlarms[index].key === 'workingCapacity') return
      if (this.tankAlarms[index].key === 'theftThreshold') return

      this.thumbColor = this.checkThresholds()
    },
    closeDialog (value) {
      this.dialog = value
    },
    getVolumeFromStrapTable (level) {
      // must consider display unit
      level = this.Maglink.LevelFromDisplay(level, this.systemSettings.levelUnit)

      // current strap
      let strap = this.tank.straptable.details

      if (strap === undefined || strap.length === 0) return 0.0

      // find index of corrisponding volume
      let index = strap.findIndex(l => l.levelMm > level)
      // not found in strap: means after last item
      if (index < 0) {
        let result = this.Maglink.VolumeToDisplay(strap[strap.length - 1].volumeLt, this.systemSettings.volumeUnit)
        return result
      }
      // calculate intermediate value
      let level1 = 0
      let vol1 = 0
      let level2 = strap[index].levelMm
      let vol2 = strap[index].volumeLt

      // first item
      if (index !== 0) {
        level1 = strap[index - 1].levelMm
        vol1 = strap[index - 1].volumeLt
      }
      let perc = (level - level1) / (level2 - level1)
      let result = vol1 + ((vol2 - vol1) * perc)
      result = this.Maglink.VolumeToDisplay(result, this.systemSettings.volumeUnit)

      return result
    },
    getLevelFromStrapTable (volume) {
      // must consider display unit
      volume = this.Maglink.VolumeFromDisplay(volume, this.systemSettings.volumeUnit)

      // current strap
      let strap = this.tank.straptable.details

      if (strap === undefined || strap.length === 0) return 0.0

      // find index of corrisponding volume
      let index = strap.findIndex(v => v.volumeLt > volume)
      // not found in strap: means after last item
      if (index < 0) {
        let result = this.Maglink.LevelToDisplay(strap[strap.length - 1].levelMm, this.systemSettings.levelUnit)
        return result
      }
      // calculate intermediate value
      let level1 = 0
      let vol1 = 0
      let level2 = strap[index].levelMm
      let vol2 = strap[index].volumeLt

      // first item
      if (index !== 0) {
        level1 = strap[index - 1].levelMm
        vol1 = strap[index - 1].volumeLt
      }
      let perc = (volume - vol1) / (vol2 - vol1)
      let result = level1 + ((level2 - level1) * perc)
      result = this.Maglink.LevelToDisplay(result, this.systemSettings.levelUnit)

      return result
    },
    checkThresholds () {
      this.isValidationOk = true

      var maxValue = this.tank.maxLevel * 1
      if (!maxValue) return 'dover-blue'

      var values = []
      // push sequence is important
      values.push(this.tank.alarmHHLevel)
      values.push(this.tank.alarmHLevel)
      values.push(this.tank.alarmLLevel)
      values.push(this.tank.alarmLLLevel)
      values.push(this.tank.alarmWaterHHLevel)
      values.push(this.tank.alarmWaterLevel)

      for (let i = 0; i < values.length; i++) {
        if (values[i] === undefined) {
          values[i] = '0'
        }
        let value = values[i] * 1 // string to number convertion

        // threshold not specified wont check
        if (value === 0) continue
        if (value > maxValue) {
          this.isValidationOk = false
          return 'red'
        }
        maxValue = value // current threshold becomes max
      }

      return 'dover-blue'
    },
    saveTank (event) {
      if (this.$refs.form.validate()) {
        // avoid setting 0%
        if (this.tank.workingCapacity === 0) this.tank.workingCapacity = 100

        this.tank.unexpectedSaleThreshold = this.tank.theftThreshold // intentionally using the same value

        this.isValidationOk = true
        this.$emit('tankSaved', this.tank.tankNumber)
      } else {
        this.isValidationOk = false
      }
    }
  }
}
</script>
